import { useTranslation } from 'react-i18next';

import { EntryListWidget } from 'src/common/components/Widgets/EntryListWidget/EntryListWidget';
import { WidgetEntryList } from 'src/common/components/Widgets/EntryListWidget/WidgetEntryList';
import { useSuspenseQuery } from '@tanstack/react-query';
import { dashboardQueries } from 'src/dashboard/Charts/queries/dashboardQueries';
import { setMinimalPromiseTime } from 'src/common/utils/setMinimalPromiseTime';
import { DASHBOARD_RSIM_STATUS, getRSimStatus } from 'src/dashboard/Charts/api/DashboardApi';
import { accountsFilterAtom } from 'src/atoms/filters/rsim-products';
import { GraphAccountsValidator } from 'src/products/GraphAccountValidator';
import { useAccountRefs } from 'src/common/components/Accounts/useAccountRefs';
import { ActiveStateChartPlaceholder } from 'src/products/GraphValidatorPlaceholders';

const RSimActiveStateContent = ({ accountRef }: { accountRef: string }) => {
  const { t } = useTranslation();

  const { data } = useSuspenseQuery<Awaited<ReturnType<typeof getRSimStatus>>>({
    queryKey: dashboardQueries.rSimStatus({ accountRef }),
    queryFn: () => setMinimalPromiseTime(getRSimStatus({ accountRef })),
  });

  const entries = [
    {
      label: t('dashboard.rSimStatusChart.legend.primary'),
      value: data.data[DASHBOARD_RSIM_STATUS.PRIMARY],
    },
    {
      label: t('dashboard.rSimStatusChart.legend.backup'),
      value: data.data[DASHBOARD_RSIM_STATUS.BACKUP],
    },
    {
      label: t('dashboard.rSimStatusChart.legend.disconnected'),
      value: data.data[DASHBOARD_RSIM_STATUS.DISCONNECTED],
    },
  ];

  return <WidgetEntryList entries={entries} />;
};

export const RSimActiveStateWidget = () => {
  const { t } = useTranslation();
  const accountRefs = useAccountRefs({ cslAccountAtom: accountsFilterAtom });

  const title = t('dashboard.rSimStatusChart.title');

  return (
    <GraphAccountsValidator
      accountRefs={accountRefs}
      fallback={<ActiveStateChartPlaceholder title={title} />}
    >
      <EntryListWidget
        title={t('dashboard.rSimStatusChart.title')}
        expectedRows={2}
        accountRef={accountRefs[0]}
      >
        {(accountRef) => <RSimActiveStateContent accountRef={accountRef} />}
      </EntryListWidget>
    </GraphAccountsValidator>
  );
};
